import React, { useState } from "react";
import { Button, Container, Row, Col, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import searchIcon from "../../assets/images/search_rgb_red.svg";
import "../../assets/styles/layers.scss";

const LayersButtons = ({ onSearch}) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = () => {
    if (onSearch) {
      onSearch(searchTerm);
    }
  };

  const handleBulkAdd = () => {
    navigate("/layer/create/multiple");
  };

  const handleAdd = () => {
    navigate("/layer/create/one");
  };

  return (
    <Container fluid className="layers-buttons-container">
      <Row className="align-items-center">
        <Col xs={8} md={2}>
          <Form.Control
            type="text"
            placeholder="Wyszukaj warstwę..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSearch();
              }
            }}
          />
        </Col>
        <Col xs={12} md={10} className="d-flex justify-content-end gap-3">
          <Button className="layers-button" onClick={handleSearch}>
            <img src={searchIcon} alt="Szukaj" style={{ width: "32px", height: "32px" }} />
          </Button>
          <Button className="layers-button-letters" onClick={handleAdd}>
            + Dodaj
          </Button>
          <Button className="layers-button-letters" onClick={handleBulkAdd}>
            + Dodaj hurtowo
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default LayersButtons;